import { Dispatch } from "react-redux";
import { AuthActionCreators, IApplicationState } from "..";
import { RecipientShieldIntervalType, RecipientShieldResultType } from '@nkr/enums/index';
import { IBaseResponse, ICenterBase, IToken, IUser } from '@nkr/models/index';

export interface IRecipientShieldResult {
    id: number,
    recipientShieldEnrollmentId: number,
    type: RecipientShieldResultType,
    patientId: string,
    patientAlias: string,
    testName: string,
    patientType: number,
    code: string,
    value: string,
    fileName: string,
    fileCount: number,
    date: string
}

export interface IRecipientShieldEnrollment {
    testId: number,
    monthIntervals: number,
    orderTypeId: number,
    dateOrdered: string,
    firstName: string,
    lastName: string,
    results: IRecipientShieldResult[]
}

export interface IRecipientShieldEnrollmentsResponse {
    data: {
        success: boolean,
        message: string,
        results: IRecipientShieldEnrollment[]
    }
}

export const ActionCreators = {
    
    getPendingEnrollments: (centerId: number, isAdmin: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<IRecipientShieldEnrollmentsResponse> => {
        var options = {
            url: `${__API__}/center/${centerId}/recipient-shield/enrollments`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IRecipientShieldEnrollmentsResponse) => {
            return Promise.resolve(response);
        });
    },

    getResultFiles: (centerId: number, resultId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/center/${centerId}/recipient-shield/download/${resultId}`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
};